import { OrganizationsResponses } from "@tfg/types/endpoints/organizations"
import { PermissionsPerScopeSchema } from "@tfg/types/schemas/communication-studio/permissions"

import { useGetPermissionsBySubscriptionPlan } from "~/gen/api/hooks/useGetPermissionsBySubscriptionPlan"

type UseGetOrganizationSubscriptionPlanPermissions =
  | OrganizationsResponses.OrganizationSubscriptionPlanPermissions
  | { permissions: undefined; isPermissionsError: boolean }

export const useGetOrganizationSubscriptionPlanPermissions = (
  subscriptionPlan: OrganizationsResponses.OrganizationSettings["subscriptionPlan"]
): UseGetOrganizationSubscriptionPlanPermissions => {
  const { data: permissionsBySubscriptionPlanQuery, isError } =
    useGetPermissionsBySubscriptionPlan(subscriptionPlan)
  const permissions = permissionsBySubscriptionPlanQuery?.data.permissions
  const result = PermissionsPerScopeSchema.safeParse(permissions)

  return {
    permissions: result.success ? result.data : undefined,
    isPermissionsError: isError,
  }
}
